import { SvgProps } from "@/utils/types";

export const Mushroom = ({
  primaryColor = "#D4DF65",
  secondaryColor = "#06B992",
  outlineColor = "#0E5654",
  className,
}: SvgProps) => {
  return (
    <svg
      width="62"
      height="65"
      viewBox="0 0 62 65"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_5_918)">
        <path
          d="M24.6031 31.892C22.2113 36.8843 14.5083 44.2718 14.5083 44.2718C12.4346 46.4053 12.9834 49.9329 15.6012 51.3358L23.1813 55.398C24.9617 56.3522 27.0707 55.9735 28.4234 54.6562C29.0493 54.0386 29.4304 53.2217 29.5668 52.3532C30.0439 49.4094 31.8535 39.0677 34.0578 37.2198"
          fill={primaryColor}
        />
        <path
          d="M22.2643 57.1303L14.6842 53.068C12.8861 52.1044 11.6772 50.4014 11.363 48.3837C11.0488 46.366 11.6869 44.3708 13.1064 42.9078C13.226 42.7904 20.6221 35.6581 22.8331 31.0455L26.3644 32.7338C23.8445 37.9864 16.1861 45.3751 15.8643 45.6792C15.3574 46.2017 15.107 46.9865 15.2278 47.7774C15.3485 48.5682 15.8219 49.2303 16.527 49.6082L24.1071 53.6705C25.0855 54.1948 26.267 54.0224 27.0627 53.2576C27.3527 52.9705 27.5571 52.5468 27.6428 52.0481C29.1383 42.8429 30.8775 37.3534 32.8025 35.7302L35.326 38.7276C34.445 39.5035 32.8046 44.6602 31.5039 52.6765C31.2871 54.0125 30.6947 55.1813 29.8018 56.0642C27.7819 58.0337 24.7499 58.4623 22.2643 57.1303Z"
          fill={outlineColor}
        />
        <path
          d="M16.4198 21.7997C18.0173 25.4241 20.8296 28.9621 24.6031 31.892C26.0303 32.9972 27.5942 34.0169 29.2865 34.9238C30.9788 35.8307 32.6849 36.5635 34.4091 37.1358C38.9249 38.6596 43.4194 39.0374 47.3443 38.3612C48.756 38.1193 49.9433 37.1105 50.3225 35.7254C53.0381 25.9373 49.7564 15.9077 41.7708 11.6282C33.7853 7.34862 23.6167 10.17 16.9654 17.8602C16.0308 18.9478 15.8442 20.4815 16.4198 21.7997Z"
          fill={secondaryColor}
        />
        <path
          d="M28.3654 36.6425C26.5938 35.6931 24.9242 34.6168 23.4054 33.4284C19.4304 30.3452 16.405 26.5909 14.6347 22.5902C13.7435 20.5696 14.0876 18.2127 15.4938 16.5837C22.881 8.02851 34.0677 5.27623 42.6967 9.9006C51.3257 14.525 55.2334 25.3552 52.2092 36.2485C51.6268 38.3303 49.846 39.9173 47.6699 40.2942C43.3313 41.0437 38.5346 40.5947 33.7884 38.9928C31.9843 38.4004 30.1588 37.6149 28.3695 36.656L28.3654 36.6425ZM18.2138 21.0139C19.7187 24.4299 22.3387 27.6492 25.8057 30.3468C28.5109 32.4546 31.8297 34.2218 35.0164 35.2829C39.1601 36.6753 43.3005 37.0789 47.0006 36.441C47.6973 36.3266 48.2524 35.8412 48.4313 35.211C50.9666 26.0978 47.8387 17.115 40.8404 13.3645C33.842 9.61402 24.6349 11.975 18.4458 19.1414C18.0248 19.6306 17.9233 20.3704 18.2138 21.0139Z"
          fill={outlineColor}
        />
        <path
          d="M40.4872 33.7333C41.4219 34.2342 42.5856 33.8825 43.0864 32.9479C43.5873 32.0133 43.2357 30.8495 42.3011 30.3487C41.3664 29.8478 40.2027 30.1994 39.7018 31.134C39.201 32.0687 39.5526 33.2324 40.4872 33.7333Z"
          fill={outlineColor}
        />
        <path
          d="M43.1209 27.4638C44.0555 27.9647 45.2192 27.6131 45.7201 26.6785C46.221 25.7438 45.8694 24.5801 44.9347 24.0792C44.0001 23.5783 42.8364 23.93 42.3355 24.8646C41.8346 25.7992 42.1863 26.963 43.1209 27.4638Z"
          fill={outlineColor}
        />
        <path
          d="M36.4357 28.2946C37.3703 28.7954 38.5341 28.4438 39.0349 27.5092C39.5358 26.5745 39.1842 25.4108 38.2496 24.9099C37.3149 24.4091 36.1512 24.7607 35.6503 25.6953C35.1494 26.63 35.5011 27.7937 36.4357 28.2946Z"
          fill={outlineColor}
        />
      </g>
      <defs>
        <clipPath id="clip0_5_918">
          <rect
            width="41.91"
            height="51.28"
            fill="white"
            transform="translate(24.2224) rotate(28.1874)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
